import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { endpoints } from "src/environments/environment";

import { Card } from "../components/card/model/card";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  MENU_URL = endpoints.menu_url;
  my_contracts = endpoints.my_contracts;
  my_contracts_v2 = endpoints.my_contracts_v2;
  constructor(private http: HttpClient) {}

  getMyContracts(profile): Observable<any> {
    return this.http.post(`${this.my_contracts}/${profile.contactId}`, {});
  }

  getMyContractsV2(profile): Observable<any> {
    return this.http.post(`${this.my_contracts_v2}/${profile.contactId}`, {});
  }

  getMenu(): Observable<any> {
    return this.http.get<any>(this.MENU_URL);
  }


  camelToUnderscore(key): string {
    if (!!key) {
      const removeSpace = key.replace(/\s/g, "");
      const convertedToSnake = removeSpace
        .replace(/\.?([A-Z])/g, (x, y) => {
          return "_" + y.toLowerCase();
        })
        .replace(/^_/, "");
      return convertedToSnake;
    }
  }

  toUnderscore(key): string {
    if (!!key) {
      const removeSpace = key.replace(/\s/g, "_");
      const convertedToSnake = removeSpace
        .replace(/\.?([A-Z])/g, (x, y) => {
          return "_" + y.toLowerCase();
        })
        .replace(/^_/, "");
      return convertedToSnake;
    }
  }
}
